import React from 'react';
export function Footer() {
  return <footer className="text-center py-8 px-5 font-sans text-sm text-gray-400 border-t border-gray-200 mt-10" data-id="element-226">
      <p data-id="element-227">© Pack Estimulación Temprana — Todos los Derechos Reservados</p>
      <p className="mt-2" data-id="element-228">
        <a href="#" className="hover:text-gray-600 transition-colors" data-id="element-229">
          Contacto
        </a>
        <span className="mx-2" data-id="element-230">|</span>
        <a href="#" className="hover:text-gray-600 transition-colors" data-id="element-231">
          Política de Privacidad
        </a>
        <span className="mx-2" data-id="element-232">|</span>
        <a href="#" className="hover:text-gray-600 transition-colors" data-id="element-233">
          Términos y Condiciones
        </a>
      </p>
      <p className="mt-4 max-w-xl mx-auto text-xs text-gray-300 leading-relaxed" data-id="element-234">
        Este producto es exclusivamente digital. Los resultados pueden variar
        según la dedicación y constancia de cada familia. Este contenido no
        sustituye el diagnóstico ni el tratamiento profesional en caso de
        retrasos en el desarrollo.
      </p>
    </footer>;
}